import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Period:", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Spellng Period:", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Maths Period:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.areEqual && _ctx.spellingPeriod)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.longDateFormat(_ctx.spellingPeriod.start, false)) + " to " + _toDisplayString(_ctx.$filters.longDateFormat(_ctx.spellingPeriod.end, false)), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.spellingPeriod)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$filters.longDateFormat(_ctx.spellingPeriod.start, false)) + " to " + _toDisplayString(_ctx.$filters.longDateFormat(_ctx.spellingPeriod.end, false)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.mathsPeriod && _ctx.mathsAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$filters.longDateFormat(_ctx.mathsPeriod.start, false)) + " to " + _toDisplayString(_ctx.$filters.longDateFormat(_ctx.mathsPeriod.end, false)), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
}